module.exports = __webpack_public_path__ + "static/img/11.7121b52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/11.png
// module id = ol2A
// module chunks = 0